import { T } from '../../styles/theme'
import XAxisLabels from './XAxisLabels'

export default function WeightChart({ data, goal, theme = T, width = 320, height = 140 }) {
  const W = width, H = height, PL = 44, PB = 28, PT = 12, PR = 28
  const cW = W - PL - PR, cH = H - PB - PT

  if (!data || data.length < 2) return (
    <div style={{ textAlign: 'center', color: theme.muted, padding: 20, fontSize: 13 }}>
      Necesitas al menos 2 mediciones para ver la gráfica
    </div>
  )

  const vals = data.map(d => d.v)
  const allVals = goal ? [...vals, goal] : vals
  const minV = Math.min(...allVals) - 1
  const maxV = Math.max(...allVals) + 1
  const xScale = i => PL + (i / (data.length - 1)) * cW
  const yScale = v => PT + (1 - (v - minV) / (maxV - minV)) * cH
  const pts = data.map((d, i) => `${xScale(i)},${yScale(d.v)}`).join(' ')
  const yTicks = [minV + 1, (minV + maxV) / 2, maxV - 1].map(v => Math.round(v * 10) / 10)
  const gradientId = `weight-gradient-${width}-${height}`

  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`}>
      {yTicks.map(v => (
        <g key={v}>
          <line x1={PL} x2={W - PR} y1={yScale(v)} y2={yScale(v)} stroke={theme.cardB} strokeWidth="1" strokeDasharray="3,3" />
          <text x={PL - 4} y={yScale(v) + 4} textAnchor="end" fill={theme.muted} fontSize="9" fontFamily="DM Mono, monospace">{v}</text>
        </g>
      ))}
      <XAxisLabels data={data} usableWidth={cW} xScale={xScale} left={PL} right={W - PR} y={H - 4} theme={theme} />
      {goal && (
        <>
          <line x1={PL} x2={W - PR} y1={yScale(goal)} y2={yScale(goal)} stroke={theme.warn} strokeWidth="1.5" strokeDasharray="5,3" opacity=".8" />
          <text x={W - PR + 2} y={yScale(goal) + 4} fill={theme.warn} fontSize="9">Meta</text>
        </>
      )}
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={theme.accent} stopOpacity=".2" />
          <stop offset="100%" stopColor={theme.accent} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon fill={`url(#${gradientId})`} points={`${PL},${PT + cH} ${pts} ${W - PR},${PT + cH}`} />
      <polyline fill="none" stroke={theme.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" points={pts} />
      {data.map((d, i) => (
        <circle key={i} cx={xScale(i)} cy={yScale(d.v)} r="3" fill={theme.accent} stroke={theme.card ?? '#fff'} strokeWidth="1.5" />
      ))}
      <line x1={PL} x2={PL} y1={PT} y2={H - PB} stroke={theme.cardB} strokeWidth="1" />
      <line x1={PL} x2={W - PR} y1={H - PB} y2={H - PB} stroke={theme.cardB} strokeWidth="1" />
      <text x="8" y={H / 2} textAnchor="middle" fill={theme.muted} fontSize="9" transform={`rotate(-90,8,${H / 2})`}>kg</text>
    </svg>
  )
}
